import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../pages/Home.vue';
import Success from '../pages/Success.vue';
import LoginPage from '../pages/LoginPage.vue';
import ConfigPage from '@/pages/ConfigPage.vue'
import PasswordPage from '@/pages/PasswordPage.vue'
import RegisterPage from "@/pages/RegisterPage.vue";
import UpdateBook from "@/pages/UpdateBook.vue";
import Users from "@/pages/Users.vue";
import UpdateUser from "@/pages/UpdateUser.vue";
import StatisticalComponent from "@/components/StatisticalComponent.vue";
import SearchBook from "@/pages/SearchBook.vue";
import Book from "@/pages/Book.vue";
import ReExamination from "@/pages/ReExamination.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'home',
    component: Home
  },
  {
    path: '/success',
    name: 'success',
    component: Success,
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: true
  },
  {
    path: '/reExamination',
    name: 'reExamination',
    component: ReExamination,
    props: true
  },
  {
    path: '/config',
    name: 'config',
    component: ConfigPage,
    props: true
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterPage,
    props: true
  },
  {
    path: '/password',
    name: 'password',
    component: PasswordPage,
    props: true
  },
  {
    path: '/updatebook/:id',
    name: 'updateBook',
    component: UpdateBook,
    props: true
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    props: true
  },
  {
    path: '/updateuser/:id',
    name: 'updateUser',
    component: UpdateUser,
    props: true
  },
  {
    path: '/statistical',
    name: 'statistical',
    component: StatisticalComponent,
    props: true
  },
  {
    path: '/searchbook',
    name: 'searchbook',
    component: SearchBook,
    props: true
  },
  {
    path: '/book/:id',
    name: 'book',
    component: Book,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
